<template>
  <van-popup v-model:show="showPopup" position="bottom">
    <DepositoPayForMX v-if="isMX" :pay-info="payInfo" @mx-close="close"></DepositoPayForMX>
    <DepositoPayForPublic v-else :pay-info="payInfo" @public-close="close"></DepositoPayForPublic>
  </van-popup>
</template>

<script setup>
import { langEnums } from '@/utils/i18n'
const { t, locale } = useI18n()
const isMX = computed(() => locale.value === langEnums.ES_MX)

const props = defineProps({
  payInfo: {
    type: Object,
    default: () => ({}),
  },
})
const showPopup = ref(false)

const close = () => {
  showPopup.value = false
  emit('close')
}

const openPopupDepositPay = () => {
  showPopup.value = true
}

const emit = defineEmits(['close'])

defineExpose({
  openPopupDepositPay,
})
</script>

<style lang="scss" scoped></style>
